<template>
  <b-row class="mt-4" align-h="center" align-v="center">
    <b-col class="text-right" cols="3">
      <b-button
        class="td-bg-blue text-light td-border-button-sm-transparent py-1 px-2'"
        size="sm"
        @click="backToStep1"
        :disabled="disabledStep1 || isEditSelectedData"
        >1</b-button
      >
      <b-button
        class="td-text-blue font-weight-bold tabel-dinamis-main-progress-stepper-text"
        variant="link"
        :disabled="disabledStep1 || isEditSelectedData"
        @click="backToStep1()"
        >Pemilihan Data</b-button
      >
    </b-col>

    <b-col
      cols="1"
      style="
        content: '';
        flex: 1;
        height: 2px;
        background-color: #e0e0e0;
        margin-inline-end: 0.5rem;
      "
    >
    </b-col>

    <b-col class="text-left" cols="3">
      <b-button
        :class="
          (disabledStep2
            ? 'bg-secondary '
            : isStep2
            ? 'td-bg-blue '
            : 'td-bg-grey ') +
          'text-light td-border-button-sm-transparent py-1 px-2'
        "
        size="sm"
        :disabled="disabledStep2 || isEditSelectedData"
        @click="goToStep2()"
        >2</b-button
      >
      <b-button
        :class="
          (disabledStep2
            ? 'text-secondary '
            : isStep2
            ? 'td-text-blue '
            : 'td-text-grey ') +
          'font-weight-bold tabel-dinamis-main-progress-stepper-text'
        "
        variant="link"
        :disabled="disabledStep2 || isEditSelectedData"
        @click="goToStep2()"
        >Visualisasi Data</b-button
      >
    </b-col>
  </b-row>
</template>

<!-- javascript section-->
<script>
//import js modules section
import utils from "../../../../utils/TabelDinamisUtils.js";

//local registration for output component
export default {
  name: "MainProgressStepper",
  data() {
    return {};
  },
  props: [
    "isStep2",
    "disabledStep2",
    "disabledStep1",
    "isEditSelectedData",
    "setIsProcessingNow",
    "updateTempDataCart",
  ],
  created() {},
  destroyed() {},
  mounted: function () {},
  computed: {},
  watch: {},
  methods: {
    backToStep1() {
      this.$emit("update:isStep2", false);
      this.setIsProcessingNow(false);
      this.updateTempDataCart(null);
      utils.scrollToUpperMost();
    },
    goToStep2() {
      this.$emit("update:isStep2", true);
      utils.scrollToUpperMost();
    },
  },
  components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
.tabel-dinamis-main-progress-stepper-text {
  font-size: 1rem !important;
  text-decoration-line: none;
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 19-04-2022 -->
